import * as React from "react";

export function isEnterKey(e: React.KeyboardEvent): boolean {
    return e.code === "Enter" || e.code === "NumpadEnter" || e.key === "Enter" || e.key === "NumpadEnter";
}
